import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=81310966&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=81310966&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81310966",
  null
  
)

export default component.exports